
var VIEW_MY = {
    showShare: true,
    showGet: true,
    showExport: true,
    showCompareList: true,
    showCourse: true,
    showTool: false,
    showBirth: false,
    showPi: false,
    showLun: false,
    showCompare: false,
    showReport: false,
    showFeedback: false,
    showAbout: false,
    showSet: true,
    showDonate: false
}

export {
    VIEW_MY
}